import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { reactive, onMounted } from 'vue'
import { orderStatusColumns } from "@/components/model/data";
import { searchAppointment } from "@/api/order";
import { useRoute } from 'vue-router';
import { formatDateTime } from "@/components/ts/components";

export default /*#__PURE__*/_defineComponent({
  __name: 'detailTable',
  setup(__props) {

const columns = [
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        customRender: ({ index }: any) => `${index + 1}`,
    },
    {
        title: "创建时间",
        dataIndex: "creationDate",
        key: "creationDate",
        customRender: ({ record }: any) => {
            return record.creationDate ? formatDateTime(record.creationDate) : "";
        },
        width:160
    },
    {
        title: "类型",
        dataIndex: "type",
        key: "type",
        customRender: ({ record }: any) => {
            return record.type === 1 ? "初诊" : "复诊"
        },
    },
    {
        title: "项目",
        dataIndex: "treatName",
        key: "treatName",
    },
    {
        title: "医生团队",
        dataIndex: "dentistName",
        key: "dentistName",
    },
    {
        title: "门诊",
        dataIndex: "clinicName",
        key: "clinicName",
    },
    {
        title: "预约时间",
        dataIndex: "time",
        key: "time",
        customRender: ({ record }: any) => {
            return record.toTime ? record.fromTime + ' - ' + record.toTime : "";
        },
        width:400
    },
    {
        title: "到店确认",
        dataIndex: "reported",
        key: "reported",
        customRender: ({ record }: any) => orderStatusColumns[record.status]
    },
    {
        title: "流程状态",
        dataIndex: "status",
        key: "status",
        customRender: ({ record }: any) => orderStatusColumns[record.status]
    }
]
const route = useRoute();
const data = reactive({
    dataSource: [],
    pagination: {
        size: "small",
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
        showTotal: (total: string) => {
            return " 共" + total + "条";
        },
        hideOnSinglePage: false,
        showSizeChanger: true,
    },
    loading: false
})

onMounted(() => {
    search()
})

const changePageIndex = (page: any) => {
    data.pagination.pageSize = page.pageSize;
    data.pagination.current = page.current;
    search();
};

const search = () => {
    data.loading = true;
    let option = {
        page: {
            currPage: data.pagination.current,
            pageSize: data.pagination.pageSize,
        },
        patientId: route.query.id,
    };
    searchAppointment(option).then((res: any) => {
        data.loading = false;
        data.dataSource = [];
        data.pagination.total = 0;
        if (null !== res) {
            data.dataSource = res.data;
            data.pagination.total = res.records;
        }
    });
};




return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_table, {
      dataSource: data.dataSource,
      loading: data.loading,
      scroll: { y: 400 },
      size: "small",
      columns: columns,
      bordered: "",
      pagination: data.pagination,
      onChange: changePageIndex
    }, null, 8, ["dataSource", "loading", "pagination"])
  ]))
}
}

})